/********************************************************************
 * Copyright (c) Certus Software, 2021.                             *
 *                                                                  *
 * This unpublished material is proprietary to Certus Software.     *
 * All rights reserved. The methods and techniques described        *
 * herein are considered confidential and/or trade secrets.         *
 * Reproduction or distribution, in whole or in part, is forbidden  *
 * except by express written permission of Certus Software.         *
 ********************************************************************/

import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {LicenseService} from '../_services/license.service';
import {Observable} from 'rxjs';
import {UserService} from '../_services/user.service';
import {switchMap, take} from 'rxjs/operators';
import {UserType} from '../_models/user';

@Injectable({
  providedIn: 'root'
})
export class HomeResolverService implements Resolve<any> {

  constructor(
    private userService: UserService
  ) {}

  resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<any>|Promise<any>|any {
    return this.userService.currentUser.pipe(
      take(1),
      switchMap(user => {
        return user?.userType === UserType.Unregistered
          ? this.userService.initGuestStats()
          : this.userService.initAccountStats()
      })
    );
  }
}
